import { CellProps } from './cell.props';

export const CellPresets: CellProps = {
  column: null,
  row: null,
  textAlign: 'left',
};
